
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetomumbaidarshancabs() {



    const cardData =
    {
        keyword: 'Pune to Mumbai Darshan Cabs',
        heading: 'Platinum24 Cabs: Pune to Mumbai Darshan Cabs',
        headingDescription: ' Platinum24 Cabs offers comfortable Pune to Mumbai Darshan Cabs, ideal for families, tourists, and corporate groups planning a sightseeing trip across the City of Dreams. Our fleet of hatchbacks, sedans, SUVs, and luxury cars ensures a smooth ride while visiting top attractions like Gateway of India, Marine Drive, Siddhivinayak Temple, and Haji Ali Dargah. With professional drivers familiar with Mumbai’s busy roads, we guarantee punctual service, safe travel, and stress-free navigation. Whether it’s a one-day city tour or an extended itinerary, Platinum24 Cabs provides affordable fares and a memorable Pune to Mumbai Darshan experience.',

        top: 'Top Places to Visit in Mumbai with Platinum24 Cabs',

"topPlaces": [
  {
    "title": "Gateway of India",
    "description": "Built in 1924, the Gateway of India is Mumbai’s most iconic landmark overlooking the Arabian Sea. Designed in Indo-Saracenic style, it commemorates the visit of King George V and Queen Mary. Visitors enjoy ferry rides to Elephanta Caves from here. The monument glows beautifully at night, attracting photographers and tourists alike. Surrounded by luxury hotels and local vendors, it is Mumbai’s proud welcoming arch."
  },
  {
    "title": "Marine Drive",
    "description": "Marine Drive, stretching 3.6 km along the coast, is famously known as the Queen’s Necklace. Its sea-facing promenade is perfect for evening walks, sunsets, and relaxation. At night, the arc-shaped lights resemble a glowing necklace. Street food stalls serve bhel puri and pav bhaji, adding flavor to the visit. Families, couples, and joggers gather here daily. Marine Drive is Mumbai’s most scenic urban escape."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus (CSMT)",
    "description": "CSMT, a UNESCO World Heritage Site, is a masterpiece of Victorian Gothic architecture built in 1887. It is one of India’s busiest railway stations, blending Indian and European design. The grand domes, stained glass, and carvings make it breathtaking. At night, the illuminated façade adds magic. It is a cultural and functional landmark of Mumbai. CSMT is the city’s architectural pride."
  },
  {
    "title": "Elephanta Caves",
    "description": "Located on Elephanta Island, these 5th–6th century caves are dedicated to Lord Shiva. The highlight is the massive Trimurti sculpture, depicting Shiva in three forms. Visitors take ferries from the Gateway of India to reach here. Surrounded by greenery and sea views, it offers a blend of heritage and nature. A UNESCO World Heritage Site, it fascinates historians and tourists alike. Elephanta Caves are Mumbai’s cultural treasure."
  },
  {
    "title": "Haji Ali Dargah",
    "description": "Haji Ali Dargah, built in Indo-Islamic style, stands on an islet in the Arabian Sea. It houses the tomb of Saint Pir Haji Ali Shah Bukhari. The walkway leading to the shrine gets submerged during high tide, adding mystique. People of all faiths visit to seek blessings. Evening qawwalis make the experience soulful. Haji Ali is Mumbai’s symbol of faith and harmony."
  },
  {
    "title": "Siddhivinayak Temple",
    "description": "Siddhivinayak Temple in Prabhadevi is Mumbai’s most famous temple dedicated to Lord Ganesha. Its golden dome and intricately adorned idol attract thousands of devotees daily. Bollywood celebrities and politicians often visit for blessings. Tuesdays and Ganesh Chaturthi are especially crowded. Devotees believe prayers here bring success and prosperity. Siddhivinayak is Mumbai’s divine spiritual hub."
  },
  {
    "title": "Juhu Beach",
    "description": "Juhu Beach is Mumbai’s lively seaside attraction, known for its vibrant street food culture. Visitors relish pav bhaji, bhel puri, and kulfi while enjoying sea breezes. Sunsets here are spectacular and photogenic. Many Bollywood stars live nearby, adding glamour. Families and tourists flock daily for leisure and fun. Juhu Beach is Mumbai’s most popular coastal retreat."
  },
  {
    "title": "Colaba Causeway",
    "description": "Colaba Causeway is Mumbai’s bustling shopping street lined with stalls, boutiques, and cafes. Tourists bargain for jewelry, clothes, handicrafts, and antiques. Iconic cafes like Leopold and Mondegar add charm to the experience. The market reflects Mumbai’s cosmopolitan lifestyle. It is always buzzing with locals and foreigners. Colaba Causeway is Mumbai’s colorful shopping paradise."
  },
  {
    "title": "Film City",
    "description": "Film City in Goregaon is the hub of Bollywood, spread across 500 acres. It features studios, sets, and shooting locations where countless films and serials are made. Visitors can take guided tours to witness live shooting. From rural backdrops to grand palaces, Film City recreates it all. It is a dream come true for cinema lovers. Film City is Mumbai’s reel-world experience."
  },
  {
    "title": "Girgaon Chowpatty",
    "description": "Girgaon Chowpatty is famous for Ganesh Visarjan celebrations and Mumbai’s street food culture. In the evenings, the beach buzzes with stalls selling sev puri, pani puri, and falooda. Festivals and fairs make it vibrant throughout the year. Families enjoy walks along the shore as the sun sets. It offers a mix of tradition, leisure, and flavor. Chowpatty is Mumbai’s cultural seaside hotspot."
  }
],


       "services": [
  {
    "name": "Pune to Mumbai Darshan Taxi",
    "description": "Experience a hassle-free city tour with our Pune to Mumbai Darshan Taxi service. Ideal for families, tourists, or groups, this service covers all major attractions in Mumbai with convenient pickup from Pune. Enjoy clean, comfortable vehicles and courteous drivers for a memorable day trip."
  },
  {
    "name": "Mumbai Darshan Cab from Pune",
    "description": "Book a reliable Mumbai Darshan Cab from Pune for sightseeing, shopping, or a full-day excursion. Our fleet includes AC sedans and SUVs, perfect for solo travelers or groups. Affordable pricing and experienced drivers ensure a smooth and enjoyable journey."
  },
  {
    "name": "Pune Mumbai Darshan Taxi Booking",
    "description": "Easily reserve your Pune Mumbai Darshan Taxi online or by phone. Our booking system is simple, fast, and transparent, giving you instant confirmation and flexible options for pickup, vehicle type, and tour customization."
  },
  {
    "name": "Taxi Service Pune to Mumbai Darshan",
    "description": "Choose our Taxi Service Pune to Mumbai Darshan for a full-day tour of Mumbai’s iconic landmarks. Our service ensures comfort, punctuality, and knowledgeable drivers to guide you through must-see spots like Gateway of India, Marine Drive, and more."
  },
  {
    "name": "Mumbai Darshan Cab Rental Pune",
    "description": "Rent a cab for Mumbai Darshan from Pune at competitive rates. Whether you're planning a solo adventure or a family outing, we offer flexible rental plans including hourly or full-day packages with optional driver services."
  },
  {
    "name": "Pune to Mumbai Darshan Taxi Fare",
    "description": "Get transparent and affordable Pune to Mumbai Darshan Taxi Fare details upfront. No hidden costs — just clear pricing based on vehicle type, trip duration, and customization. Special discounts available for early bookings and return trips."
  },
  {
    "name": "Mumbai Darshan Private Taxi Pune",
    "description": "Enjoy privacy and convenience with our Mumbai Darshan Private Taxi service from Pune. Ideal for couples, families, or VIP guests, this option includes a dedicated vehicle and driver for a personalized sightseeing experience."
  },
  {
    "name": "Mumbai Darshan Cab Packages Pune",
    "description": "Explore flexible and budget-friendly Mumbai Darshan Cab Packages from Pune. Choose from half-day, full-day, or multi-day tours including major attractions, fuel, tolls, and driver charges in one all-inclusive package."
  },
  {
    "name": "Pune to Mumbai Darshan One Way Cab",
    "description": "Need a one-way ride for sightseeing in Mumbai? Our Pune to Mumbai Darshan One Way Cab service offers economical and comfortable travel without the need to book a return trip. Perfect for short stays or connecting journeys."
  },
  {
    "name": "Taxi Charges Pune to Mumbai Darshan",
    "description": "Curious about Taxi Charges from Pune to Mumbai Darshan? We provide transparent rate cards based on the vehicle type and trip duration, ensuring you always know what you’re paying for. No surge pricing or last-minute surprises."
  },
  {
    "name": "Pune to Mumbai Darshan Taxi Hire",
    "description": "Hire a taxi from Pune to Mumbai Darshan for sightseeing, shopping, or leisure trips. Our service offers flexible booking, verified drivers, and sanitized cars — ensuring a safe and enjoyable journey every time."
  },
  {
    "name": "Mumbai Darshan Day Trip Cab Pune",
    "description": "Planning a quick day tour? Choose our Mumbai Darshan Day Trip Cab from Pune for a seamless travel experience. Start early, cover top tourist spots, and return the same day in comfort and style."
  },
  {
    "name": "Pune Mumbai Darshan Outstation Taxi",
    "description": "Our Pune Mumbai Darshan Outstation Taxi service is perfect for travelers looking to combine a city tour with intercity travel. Comfortable cars, experienced drivers, and timely service make your outstation experience smooth and memorable."
  },
  {
    "name": "Mumbai Darshan Taxi with Driver Pune",
    "description": "Relax and explore Mumbai with our Mumbai Darshan Taxi with Driver service from Pune. Our trained drivers not only navigate efficiently but also offer local insights to enrich your sightseeing journey."
  },
  {
    "name": "Taxi Service Pune to Mumbai Darshan",
    "description": "Enjoy complete convenience with our Taxi Service from Pune to Mumbai Darshan. Whether you’re a solo traveler, couple, or group, we ensure reliable pickups, customizable routes, and affordable fares — all backed by 24x7 customer support."
  }
],
"tableData": [
  ["Pune to Mumbai Darshan Taxi", "Mumbai Darshan Cab from Pune"],
  ["Pune Mumbai Darshan Taxi Booking", "Taxi Service Pune to Mumbai Darshan"],
  ["Mumbai Darshan Cab Rental Pune", "Pune to Mumbai Darshan Taxi Fare"],
  ["Mumbai Darshan Private Taxi Pune", "Mumbai Darshan Cab Packages Pune"],
  ["Pune to Mumbai Darshan One Way Cab", "Taxi Charges Pune to Mumbai Darshan"],
  ["Pune to Mumbai Darshan Taxi Hire", "Mumbai Darshan Day Trip Cab Pune"],
  ["Pune Mumbai Darshan Outstation Taxi", "Mumbai Darshan Taxi with Driver Pune"],
  ["Taxi Service Pune to Mumbai Darshan", "—"]
],


       "whychoose": [
  {
    "WhyChooseheading": "Reliable Pune to Mumbai Darshan Cabs Service",
    "WhyChoosedescription": "Platinum24 Cabs offers dependable and comfortable Pune to Mumbai Darshan cab services for a hassle-free travel experience."
  },
  {
    "WhyChooseheading": "Wide Selection of Vehicles for Darshan Trips",
    "WhyChoosedescription": "Choose from hatchbacks, sedans, SUVs, and tempo travellers to perfectly match your group size and comfort needs."
  },
  {
    "WhyChooseheading": "Clean and Sanitized Cabs for Your Safety",
    "WhyChoosedescription": "All vehicles are thoroughly cleaned and sanitized before each trip to ensure a safe and pleasant journey."
  },
  {
    "WhyChooseheading": "Experienced Drivers Skilled in Pune-Mumbai Routes",
    "WhyChoosedescription": "Our professional drivers are well-versed with the best routes for timely and smooth Pune to Mumbai Darshan travel."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Costs",
    "WhyChoosedescription": "Enjoy all-inclusive fares covering fuel, tolls, and driver allowances with no surprises."
  },
  {
    "WhyChooseheading": "24/7 Customer Support for Easy Booking",
    "WhyChoosedescription": "Our support team is available round the clock to assist you with your Pune to Mumbai Darshan cab bookings."
  },
  {
    "WhyChooseheading": "Flexible Rental Options for Day Trips and Beyond",
    "WhyChoosedescription": "Choose from hourly, daily, or customized rental packages tailored to your Pune to Mumbai travel plans."
  },
  {
    "WhyChooseheading": "Quick Online Booking with Instant Confirmation",
    "WhyChoosedescription": "Book your Pune to Mumbai Darshan cab swiftly and securely through our website or app with real-time confirmation."
  }
]






















    }

const faqData = [
    {
        question: 'Does Platinum24 Cabs offer Pune to Mumbai Darshan cab services?',
        answer: 'Yes, Platinum24 Cabs provides reliable and comfortable Pune to Mumbai Darshan cab services for sightseeing and travel.',
    },
    {
        question: 'How can I book a Pune to Mumbai Darshan cab with Platinum24 Cabs?',
        answer: 'You can easily book your Pune to Mumbai Darshan cab through our website, mobile app, or by contacting our 24x7 customer support.',
    },
    {
        question: 'What types of vehicles are available for Pune to Mumbai Darshan trips?',
        answer: 'We offer a range of vehicles including sedans, SUVs, and luxury cars to make your Mumbai Darshan trip enjoyable.',
    },
    {
        question: 'Can I customize the itinerary for Pune to Mumbai Darshan cabs?',
        answer: 'Yes, Platinum24 Cabs allows you to customize your Pune to Mumbai Darshan itinerary as per your preferences.',
    },
    {
        question: 'Are the drivers experienced with Pune to Mumbai routes and sightseeing spots?',
        answer: 'Absolutely, our drivers are professional, licensed, and knowledgeable about Pune to Mumbai routes and popular sightseeing locations.',
    },
    {
        question: 'Is Pune to Mumbai Darshan cab service available on a round-trip basis?',
        answer: 'Yes, we offer flexible round-trip packages for Pune to Mumbai Darshan cab services.',
    },
    {
        question: 'Are safety and hygiene protocols followed for Pune to Mumbai Darshan cabs?',
        answer: 'All vehicles are regularly sanitized, and drivers follow strict safety measures to ensure your health and safety.',
    },
    {
        question: 'Is Pune to Mumbai Darshan cab service available 24x7?',
        answer: 'Yes, Platinum24 Cabs offers 24x7 booking and cab services for Pune to Mumbai Darshan trips.',
    },
    {
        question: 'What payment options are accepted for Pune to Mumbai Darshan cab bookings?',
        answer: 'We accept cash, digital wallets, UPI, and card payments for a hassle-free booking experience.',
    },
    {
        question: 'Can I specify pickup and drop-off points for Pune to Mumbai Darshan cabs?',
        answer: 'Yes, you can customize your pickup and drop locations as per your travel convenience.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Ajay Kulkarni',
        feedback: 'Platinum24 Cabs made my Pune to Mumbai Darshan trip smooth and memorable with excellent service.',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Neha Patil',
        feedback: 'Professional drivers and comfortable vehicles made our Pune to Mumbai sightseeing enjoyable.',
        rating: 5,
    },
];




































































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "pune-cab-service" },
        { place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "pune-taxi-hire" },
        { place: "/images/keyword/3.jpg", text: "Pune Online Cab Booking", link: "pune-online-cab-booking" },
        { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "best-cab-service-in-pune" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cabs", link: "pune-to-mumbai-cabs" },
        { place: "/images/keyword/6.jpg", text: "Pune to Nashik Cabs", link: "pune-to-nashik-cabs" },
        { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "pune-to-mahabaleshwar-cabs" },
        { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cabs", link: "pune-to-lonavala-cabs" },
        { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
        { place: "/images/keyword/10.jpg", text: "Pune to Bhimashankar Cab", link: "pune-to-bhimashankar-cab" },
        { place: "/images/keyword/11.jpg", text: "Pune to Konkan Darshan Cabs", link: "pune-to-konkan-darshan-cabs" },
        { place: "/images/keyword/12.jpg", text: "Pune Outstation Cabs", link: "pune-outstation-cabs" },
        { place: "/images/keyword/13.jpg", text: "Ashtavinayak Darshan Cab", link: "ashtavinayak-darshan-cab" },
        { place: "/images/keyword/14.jpg", text: "Pune to Goa Cabs", link: "pune-to-goa-cabs" },
        { place: "/images/keyword/15.jpg", text: "Cabs Services Near Me", link: "cabs-services-near-me" },
        { place: "/images/keyword/16.jpg", text: "Corporate Cab Service in Pune", link: "corporate-cab-service-in-pune" },
        { place: "/images/keyword/17.jpg", text: "Pune to Mumbai Airport Cabs", link: "pune-to-mumbai-airport-cabs" },
        { place: "/images/keyword/18.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
        { place: "/images/keyword/20.jpg", text: "Innova Crysta On Rent in Pune", link: "innova-crysta-on-rent-in-pune" },
        { place: "/images/keyword/21.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
        { place: "/images/keyword/23.jpg", text: "Ertiga On Rent in Pune", link: "ertiga-on-rent-in-pune" },
        { place: "/images/keyword/24.jpg", text: "Pune to Sambhaji Nagar Taxi", link: "pune-to-sambhaji-nagar-taxi" },
        { place: "/images/keyword/25.jpg", text: "Pune to Ganpatipule Taxi", link: "pune-to-ganpatipule-taxi" }
    ];









const puneToMumbaiDarshanSchema = {
  "@context": "https://schema.org",
  "@type": "TaxiService",
  "name": "Platinum24 Cabs",
  "url": "https://www.platinum24cab.com",
  "description": "Reliable Pune to Mumbai Darshan cab service offering private taxi hire, day trips, affordable packages, and taxi services with driver for Mumbai Darshan tours.",
  "areaServed": [
    {
      "@type": "Place",
      "name": "Pune"
    },
    {
      "@type": "Place",
      "name": "Mumbai"
    }
  ],
  "serviceType": [
    "Pune to Mumbai Darshan Taxi",
    "Mumbai Darshan Cab from Pune",
    "Pune Mumbai Darshan Taxi Booking",
    "Taxi Service Pune to Mumbai Darshan",
    "Mumbai Darshan Cab Rental Pune",
    "Pune to Mumbai Darshan Taxi Fare",
    "Mumbai Darshan Private Taxi Pune",
    "Mumbai Darshan Cab Packages Pune",
    "Pune to Mumbai Darshan One Way Cab",
    "Taxi Charges Pune to Mumbai Darshan",
    "Pune to Mumbai Darshan Taxi Hire",
    "Mumbai Darshan Day Trip Cab Pune",
    "Pune Mumbai Darshan Outstation Taxi",
    "Mumbai Darshan Taxi with Driver Pune",
    "Taxi Service Pune to Mumbai Darshan"
  ],
  "telephone": "+91-XXXXXXXXXX"
};






    return (
        <div>

<Helmet>
  <title>Pune to Mumbai Darshan Cabs | Mumbai Darshan Taxi Service from Pune</title>
  <meta
    name="description"
    content="Reliable Pune to Mumbai Darshan cab service offering private taxi hire, day trips, affordable packages, and taxi services with driver for Mumbai Darshan tours."
  />
  <meta
    name="keywords"
    content="Pune to Mumbai Darshan Taxi, Mumbai Darshan Cab from Pune, Pune Mumbai Darshan Taxi Booking, Taxi Service Pune to Mumbai Darshan, Mumbai Darshan Cab Rental Pune, Pune to Mumbai Darshan Taxi Fare, Mumbai Darshan Private Taxi Pune, Mumbai Darshan Cab Packages Pune, Pune to Mumbai Darshan One Way Cab, Taxi Charges Pune to Mumbai Darshan, Pune to Mumbai Darshan Taxi Hire, Mumbai Darshan Day Trip Cab Pune, Pune Mumbai Darshan Outstation Taxi, Mumbai Darshan Taxi with Driver Pune, Taxi Service Pune to Mumbai Darshan"
  />
  <script type="application/ld+json">
    {JSON.stringify(puneToMumbaiDarshanSchema)}
  </script>
</Helmet>
            <div
                className="breadcumb-wrapper"
                // style={{ backgroundImage: "url('/img/breadcumb/breadcumb-bg.jpg')" }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                        <div className="breadcumb-menu-wrap">
                        </div>
                    </div>
                </div>
            </div>










            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/81.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>
                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        <div className="service-icon">
                                            🚖
                                        </div>
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Platinum24 Cabs</span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Platinum24 Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917507048333" className="pc-call">+91 7507048333</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/917507048333"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917507048333" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@platinum24cab.com" className="pc-email">
                                            booking@platinum24cab.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Platinum24 Cabs</strong><br />
                                            OFFICE NO.2, SECTOR NO.4, PLOT NO.295(S), SAI GANGA APARTMENT, ABOVE UMED ELECTRICAL, NEAR ACORD HOSPITAL
                                            FIRST FLOOR, SANT NAGAR, MOSHI, PUNE 412105
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetomumbaidarshancabs;